import { all, call, put, select, take, takeLatest } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import fireToastError from '../../actions/toasts/fireToastError'
import fireToastSuccess from '../../actions/toasts/fireToastSucces'
import { requestDeleteLogoAccepted } from '../../actions/userObject/profile/requestDeleteLogo'
import i18n from '../../i18n'
import { deleteLogo as requestDelete } from '../../models/Object'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'
import { UserProfileActions } from '../../reducers/userObject/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* deleteLogo() {
  try {
    const actionNames = fetchActionsName(ActionNames.DeleteUserLogo)
    const calendarId = yield select(getCalendarId)
    const [userProfile] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, requestDelete)),
    ])
    yield call(userProfile.service, calendarId)
    yield put(requestDeleteLogoAccepted())
  } catch (e) {
    yield put(fireToastError(i18n.t('cannot_remove_logo')))
  }
}

function* updateAccepted() {
  yield put(fireToastSuccess(i18n.t('user_profile_updated')))
}

export default function* () {
  yield takeLatest(UserProfileActions.RequestDeleteUserProfileLogo, deleteLogo)
  yield takeLatest(UserProfileActions.UserProfileLogoWasDeleted, updateAccepted)
}
